import { render, staticRenderFns } from "./merchNum.vue?vue&type=template&id=864e0eea&"
import script from "./merchNum.vue?vue&type=script&lang=js&"
export * from "./merchNum.vue?vue&type=script&lang=js&"
import style0 from "./merchNum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports